import addClass from '../../general/class/addClass';
import removeClass from '../../general/class/removeClass';

import getPosition from './utils/getPosition';

// ----------------------------------------------------------------------------

function selectCell(element: HTMLElement, rowIndex: number, columnIndex: number): void {
    const elCell = getPosition(element, rowIndex, columnIndex);

    if (elCell) {
        addClass(elCell, 'highlighted-cell');
    }
}

function clear(element: HTMLElement): void {
    const listCell = element.querySelectorAll('td');

    // Foreach List Cell
    for (const elCell of listCell) {
        removeClass(elCell, 'highlighted-cell');
    }
}

const event = (function (): any {
    function select(element: any): void {
        // Create event (mouse enter)
        element.on('mouseenter', 'tbody td', function (this: any): any {
            const columnIndex = element.cell(this).index().column;

            element.cells().nodes().removeClass('highlight');
            element.column(columnIndex).nodes().addClass('highlight');
        });
    }

    // ------------------------------------------------------------------------

    return {
        select,
    };
})();

// ----------------------------------------------------------------------------

export { selectCell, clear, event };
